// extracted by mini-css-extract-plugin
export default {"content":"styles_content__1EApo","footer":"styles_footer__7NqX8"};